<template>
  <v-app>
    <v-app-bar app dense elevation="0" id="appbar" :color="color">
        <v-container>
          <v-layout row>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-btn href="#" v-bind="size" text>H o m e</v-btn>
            <v-spacer></v-spacer>
            <v-btn href="#music" v-bind="size" text>M u s i c</v-btn>
            <v-spacer></v-spacer>
            <v-btn href="#videos" v-bind="size" text>V i d e o s</v-btn>
            <v-spacer></v-spacer>
            <v-btn href="#about" v-bind="size" text>A b o u t</v-btn>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
          </v-layout>
        </v-container>
    </v-app-bar>
    <v-main class="pa-0 ma-0">
      <HelloWorld id="main" />
    </v-main>
    <v-footer padless>
      <v-card flat tile class="lighten-3 text-center" width="100%">
        <v-card-text>
          <v-btn
            v-for="social in socials"
            :key="social.img"
            class="mx-3"
            icon
            :href="social.link" target="blank"
          >
            <v-icon size="24px">
              {{ social.img }}
            </v-icon>
          </v-btn>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-text>
          <strong> &copy; {{ new Date().getFullYear() }} Lockbox.</strong> Website by <a href="https://sandbergsoftware.com" target="blank">Erik Sandberg</a>
        </v-card-text>

      </v-card>
    </v-footer>
  </v-app>
</template>

<script>
import HelloWorld from "./components/HelloWorld";

export default {
  name: "App",

  created () {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll);
  },
  
  components: {
    HelloWorld,
  },

  methods: {
   handleScroll: function() {
    if (window.scrollY > 0) {
      this.$data.color = ""
    }
    else {
      this.$data.color = "transparent"
    }
    }
  },
  computed: {
    size () {
      const size = {xs:'x-small',sm:'small',lg:'large',xl:'x-large'}[this.$vuetify.breakpoint.name];
      return size ? { [size]: true } : {}
    }
  },

  data: () => ({
    color: "transparent",
    socials: [
      { img: "mdi-spotify", link: "https://open.spotify.com/artist/4yqp9NiO7zJLy1eHzb54Ro?si=rsCRLAPxQVuRfGZPPtX4YQ"},
      { img: "mdi-soundcloud", link: "https://soundcloud.com/lockboxmusic" },
      { img: "mdi-instagram", link: "https://www.instagram.com/lockboxmusic/" },
      { img: "mdi-discord", link: "https://discord.com/invite/qje5EU3" },
      { img: "mdi-twitter", link: "https://twitter.com/Lockboxmusic" },
    ],
  }),
};
</script>

<style>
html {
  scroll-behavior: smooth;
}
</style>